import type { Thing, WithContext } from 'schema-dts';
import type { JsonLdGraphContent } from './schemas';

export function JsonLd({ schema }: { schema: WithContext<Thing> | JsonLdGraphContent }) {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
}
